import { Instance, types } from "mobx-state-tree";
import { L10nId } from "@fidget/common/i18n";
import { ChatNotificationStore } from "@fidget/common/models/mst/ui/ChatNotificationStore";
import { AuthErrors } from "../../services/authService";
import { servicesGetters } from "../utils";
import { UiEventListener } from "./eventHandler";
import { MainNotificationStore } from "./MainNotificationStore";

export const UiStore = types.compose(
  "UiStore",
  ChatNotificationStore,
  MainNotificationStore,
  types
    .model({
      isWidgetInitializing: types.boolean,
      initializationError: types.maybe(
        types.enumeration<AuthErrors>("AuthErrors", Object.values(AuthErrors))
      )
    })
    .views(servicesGetters)
    .views((self) => ({
      get initializationErrorMessageId(): L10nId | undefined {
        switch (self.initializationError) {
          case undefined:
            return undefined;
          case AuthErrors.RateLimitExceeded:
            return "widget.initialization.rateLimitExceeded";
          case AuthErrors.OAuthError:
            return "widget.initialization.oauthError";
          case AuthErrors.GeneralAuthError:
          default:
            return "widget.initialization.generalAuthError";
        }
      },
    }))
    .actions((self) => ({
      setIsWidgetInitializing(value: boolean) {
        self.isWidgetInitializing = value;
      },
      setInitializationError(error: AuthErrors) {
        self.initializationError = error;
      }
    }))
    .actions((self) => {
      const eventListenerName = "UiStoreEventListener";

      const actions = {
        afterCreate() {
          self.eventListener.addGlobalListener(
            new UiEventListener(() => self as IUiStore, eventListenerName)
          );
        },

        beforeDestroy() {
          self.eventListener.removeGlobalListener(eventListenerName);
        }
      };

      return actions;
    })
);

export interface IUiStore extends Instance<typeof UiStore> {}
